import { FC } from 'react';

interface DocumentIconProps {
    className?: string;
}

export const DocumentIcon: FC<DocumentIconProps> = ({ className }) => {
    return (
        <svg 
            width="16" 
            height="16" 
            viewBox="0 0 16 16" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path 
                d="M9.6665 1.3335H3.99984C3.64622 1.3335 3.30708 1.47397 3.05703 1.72402C2.80698 1.97407 2.6665 2.31321 2.6665 2.66683V13.3335C2.6665 13.6871 2.80698 14.0263 3.05703 14.2763C3.30708 14.5264 3.64622 14.6668 3.99984 14.6668H11.9998C12.3535 14.6668 12.6926 14.5264 12.9426 14.2763C13.1927 14.0263 13.3332 13.6871 13.3332 13.3335V5.00016L9.6665 1.3335Z" 
                stroke="currentColor" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
            <path 
                d="M9.3335 1.3335V5.3335H13.3335" 
                stroke="currentColor" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
            <path 
                d="M10.6668 8.6665H5.3335" 
                stroke="currentColor" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
            <path 
                d="M10.6668 11.3335H5.3335" 
                stroke="currentColor" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
            <path 
                d="M6.66683 6H5.3335" 
                stroke="currentColor" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
        </svg>
    );
};
